let isLoaded = false;
let loadingPromise: Promise<void> | null = null;

export function loadRecaptchaScript(): Promise<void> {
	if (isLoaded) return Promise.resolve();
	if (loadingPromise) return loadingPromise;

	loadingPromise = new Promise<void>((resolve, reject) => {
		const script = document.createElement('script');
		script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LeBC-QqAAAAAIVQrWJt0xkFHjwIwr8ZngUnXCuQ';
		script.async = true;
		script.defer = true;

		script.onload = () => {
			isLoaded = true;
			resolve();
		};

		script.onerror = (err) => {
			loadingPromise = null;
			reject(err);
		};

		document.body.appendChild(script);
	});

	return loadingPromise;
}
